var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.25C11.3516 3.25 13.8828 6.0625 14 9.25V11.6875C14 12.0156 13.7422 12.25 13.4375 12.25C13.1094 12.25 12.875 12.0156 12.875 11.6875V9.25C12.875 6.57812 10.6719 4.39844 8 4.39844C5.30469 4.39844 3.125 6.57812 3.125 9.25V11.6875C3.125 12.0156 2.82031 12.25 2.53906 12.25C2.23438 12.25 2 12.0156 2 11.6875V9.25C2.09375 6.0625 4.625 3.25 8 3.25ZM5.75 9.25C6.14844 9.25 6.5 9.60156 6.5 10.0234V13C6.5 13.4219 6.14844 13.75 5.75 13.75H5.375C4.53125 13.75 3.875 13.0938 3.875 12.25V10.7734C3.875 9.92969 4.53125 9.25 5.375 9.25H5.75ZM10.625 9.25C11.4453 9.25 12.125 9.92969 12.125 10.7734V12.25C12.125 13.0938 11.4453 13.75 10.625 13.75H10.25C9.82812 13.75 9.5 13.4219 9.5 13V10.0234C9.5 9.60156 9.82812 9.25 10.25 9.25H10.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/IconSupport.5d0255b20a313160b113129adbe499b2.svg";
export { ForwardRef as ReactComponent };